import React from 'react';
import { EmptyState, EmptyStateDescription, EmptyStateIllustration, EmptyStateTitle, FlexBox } from '@vp/swan';
import { text } from 'src/utils/localizationUtil';
import './PlaceholderPreview.css';

export const PlaceholderPreview = () => {
  return (
    <FlexBox className="preview-placeholder" justifyContent="center" alignItems="center">
      <EmptyState display="flex" className="preview-placeholder-inner">
        <EmptyStateIllustration illustrationType="designServices" className="preview-image-container" />
        <EmptyStateTitle fontSkin="title-subsection" textAlign="center">
          {text('preview-title')}
        </EmptyStateTitle>
        <EmptyStateDescription fontSkin="body-standard" textAlign="center">
          {text('preview-label')}
        </EmptyStateDescription>
      </EmptyState>
    </FlexBox>
  );
};

PlaceholderPreview.displayName = 'PlaceholderPreview';
